import {
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';

import { takeUntilDestroy } from "take-until-destroy";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SelfSchedulingService } from "../../../app-main/self.scheduling/services";
import { IntlServicePP } from "../../intl/services/intl.service";
import { WindowRef } from "@progress/kendo-angular-dialog";
import { PopupWindowService } from "../../services/popup.window.service";
import { LogManager } from 'src/common/log/log.manager';
import { LogCat } from 'src/common/log/log.categories';
import { SelfSchedulingCommonService } from 'src/app-main/self.scheduling/services/self.scheduling.common.service';

@Component({
	selector: 'contact-page',
	templateUrl: './contact-page.component.html',
	styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit, OnDestroy {
	public htmlContent: SafeHtml;

	constructor(public selfSchedulingService: SelfSchedulingService, private changeDetector: ChangeDetectorRef,
		private intlServicePP: IntlServicePP, private sanitizer: DomSanitizer, public window: WindowRef, 
		public popupWindowService: PopupWindowService, private commonService: SelfSchedulingCommonService) {
	}

	ngOnInit(): void {
		this.selfSchedulingService.GetContactInfoHtml(this.intlServicePP.usedLanguage.languageKey).pipe(takeUntilDestroy(this))
			.subscribe((contactInfoHtml) => {
				if (contactInfoHtml) {
					this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(contactInfoHtml);
					this.changeDetector.markForCheck();
				}
			}, (error) => {
				LogManager.debug(LogCat.SelfScheduling.General, "Unknown error", error);
				this.commonService.showErrorNotification("UnknownError");
			});
	}

	ngOnDestroy(): void {
	}
}
